/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface ErlassDetailControllerUnlinkErlassDokumentV1$Params {
  erlassID: number;
  uploadID: string;
}

export function erlassDetailControllerUnlinkErlassDokumentV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerUnlinkErlassDokumentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerUnlinkErlassDokumentV1.PATH, 'delete');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.path('uploadID', params.uploadID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

erlassDetailControllerUnlinkErlassDokumentV1.PATH = '/v1/compliance/erlasse/{erlassID}/dokumente/{uploadID}';
